import { render, staticRenderFns } from "./TradingOrders.vue?vue&type=template&id=4f3de6fe&scoped=true&"
import script from "./TradingOrders.vue?vue&type=script&lang=js&"
export * from "./TradingOrders.vue?vue&type=script&lang=js&"
import style0 from "./TradingOrders.vue?vue&type=style&index=0&id=4f3de6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3de6fe",
  null
  
)

export default component.exports